import character_alignment_left from './btn_character_alignment_left.svg';
import character_alignment_center from './btn_character_alignment_center.svg';
import character_alignment_right from './btn_character_alignment_right.svg';
import character_alignment_top from './btn_character_alignment_top.svg';
import character_alignment_middle from './btn_character_alignment_middle.svg';
import character_alignment_bottom from './btn_character_alignment_bottom.svg';

/* 黒板文言 */
export const blackboardInfo = [
  { id: 0, header: '工事名', data: 'サンプル工事', left: 'blackboard-row-w20', right: 'blackboard-row-w80' },
  { id: 1, header: '工種', data: 'サンプル工事', left: 'blackboard-row-w20', right: 'blackboard-row-w80' },
  { id: 2, header: '種別', data: 'サンプル工事', left: 'blackboard-row-w20', right: 'blackboard-row-w80' },
  { id: 3, header: '土木共通仕様書番号', data: '0123456789', left: 'blackboard-row-w43', right: 'blackboard-row-w57' },
  { id: 4, header: '実施日', data: '2023年2月7日', left: 'blackboard-row-w43', right: 'blackboard-row-w57' },
  { id: 5, header: '実施会社', data: 'DATTJAPPAN株式会社', left: 'blackboard-row-w43', right: 'blackboard-row-w57' },
];

/* 黒板色 */
export const blackBoardColorButtons = [
  { blackboardColor: 'light-green', selected: false },
  { blackboardColor: 'white', selected: false },
  { blackboardColor: 'black-green', selected: true },
  { blackboardColor: 'green', selected: false },
];

/* フォントサイズのボタン */
export const fontSizeButtons = [
  { id: 'small', htmlFor: 'small', value: '小', selected: false },
  { id: 'normal', htmlFor: 'normal', value: '中', selected: true },
  { id: 'large', htmlFor: 'large', value: '大', selected: false },
];

/* フォントの色ボタン */
export const fontColorButtons = [
  { fontColor: 'white', selected: true },
  { fontColor: 'red', selected: false },
  { fontColor: 'light-green', selected: false },
  { fontColor: 'yellow', selected: false },
  { fontColor: 'light-blue', selected: false }
];

/* 左右の揃えのロゴ */
export const alignmentLogos = [
  { value: 'left', src: character_alignment_left, alt: '左揃えのロゴ' },
  { value: 'center', src: character_alignment_center, alt: '中央揃えのロゴ' },
  { value: 'right', src: character_alignment_right, alt: '右揃えのロゴ' },
];

/* 左右の揃えの上下の揃えのロゴ */
export const charPlacementLogos = [
  { value: 'top', src: character_alignment_top, alt: '上揃えのロゴ' },
  { value: 'middle', src: character_alignment_middle, alt: '中央揃えのロゴ' },
  { value: 'bottom', src: character_alignment_bottom, alt: '下揃えのロゴ' },
];

/** 黒板デザインパラメーター(初期表示時) */
export const blackBoardDesign = {
  color: 'black-green',
  opacity: 100,
  fontSize: 'normal',
  fontColor: 'white',
  alignment: 'left',
  placement: 'center',
}

/**黒板データのid */
export const blackboardDataId = {
  constructionName: 0,
  constructionType: 1,
  inspectionKind: 2,
  commonNumber: 3,
  date: 4,
  company: 5,
}